import React from 'react';
import { mediaUrl } from '../../api/client';

// Aspect-ratio aware image wrapper matching the theme's .sf-image element.
export default function Image({ src, alt = '', ratio, className = '', imgClassName = '', style = {}, loading = 'lazy', fit, ...rest }) {
  const url = mediaUrl(src);
  return (
    <div className={`sf-image ${className}`} style={{ ...(ratio ? { '--aspect-ratio': ratio } : {}), ...style }} {...rest}>
      {url ? (
        <img src={url} alt={alt} loading={loading} className={imgClassName} style={fit ? { objectFit: fit } : undefined} />
      ) : (
        <div className="eg-img-placeholder" />
      )}
    </div>
  );
}
